export const marketingConsentServicesNO = [
  'Forsikring',
  'Kredittscore',
  'Bedriftslån',
  'Sikret lån',
  'Kredittkort',
  'Innskuddskonto',
];
